import React, { useEffect, useState } from 'react';
import { Drawer, Button, Space, Typography, Dropdown, Alert } from 'antd';
import { FullscreenOutlined, LinkOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import CallDetailView from './CallDetailView';

export default function SidePanel({ contactId, open, onClose, onEvalCreated }) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!contactId || !open) return;
    setDetail(null);
    setError(null);
    setLoading(true);
    api.get(`/api/calls/${contactId}`)
      .then((res) => setDetail(res.data))
      .catch((err) => {
        const status = err.response?.status;
        const msg = err.response?.data?.error;
        if (status === 404) setError(msg || 'Call not found or access denied.');
        else if (status === 403) setError(msg || 'No campaign access.');
        else setError(`Failed to load call details (${status ?? 'network error'}).`);
        setDetail(null);
      })
      .finally(() => setLoading(false));
  }, [contactId, open]);

  return (
    <Drawer
      title={
        <Space>
          <Typography.Text strong>Contact {contactId}</Typography.Text>
          <Dropdown
            trigger={['click']}
            menu={{
              items: [
                {
                  key: 'navigate',
                  label: 'Navigate to full page',
                  icon: <LinkOutlined />,
                  onClick: () => { onClose(); navigate(`/calls/${contactId}`); },
                },
                {
                  key: 'new-window',
                  label: 'Open in new window',
                  icon: <LinkOutlined />,
                  onClick: () => window.open(`/calls/${contactId}`, '_blank'),
                },
              ],
            }}
          >
            <Button size="small" icon={<FullscreenOutlined />}>
              Full Page
            </Button>
          </Dropdown>
        </Space>
      }
      placement="right"
      width="75vw"
      open={open}
      onClose={onClose}
      styles={{ body: { padding: 16 } }}
    >
      {error
        ? <Alert type="error" message={error} showIcon />
        : <CallDetailView detail={detail} loading={loading} contactId={contactId} sidePanel onEvalCreated={onEvalCreated} />
      }
    </Drawer>
  );
}
